import React, {useRef, useLayoutEffect, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import './NoInventories.css'
import moment from 'moment'

function NoInventories(props) {

    const scrollable = useRef()

    


    const adjustHeight = () => {
        // calculate size of the table
        const html = document.getElementsByTagName("html");
        if (!!html) {
            // console.log("html", html)
            const htmlHeight = html[0].clientHeight;

            // console.log("html height", htmlHeight)

            // const tbl = document.getElementById('inventory_container');
            const tbl = scrollable.current;
            // console.log("scrollable", tbl)
            if (!!tbl) {
                const rect = tbl.getBoundingClientRect()
                // console.log("Scrollable position", rect )

                // calculate height
                const tblHeight = htmlHeight - rect.top - 50;
                // console.log("Scrollable new height", tblHeight )
                tbl.style.height = `${tblHeight}px`
            }

        }
    }



    useEffect(() => {
        const handleWindowResize = () => {
            adjustHeight();
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);



    useLayoutEffect(() => {
        adjustHeight();
    })

    // if no inventories list is empty
    if (!!!props.noInventories || props.noInventories.length === 0) {
        return null
    }



    return (
        <div className={`table-container noinv-recs ${props.noInventories.length > 0 ? 'noinv-recs-with-data':''}`} ref={scrollable}>
            <Table >
                <thead>
                    <tr>
                        {props.columns.map((col, index) => (
                            <th key={index}>{col.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.noInventories.map((noinv, rowidx) => {
                        return (
                        <tr key={rowidx}>  
                            {props.columns.map((col, colindex) => {
                                if (col.type === 'date') {
                                    return (
                                        <td key={colindex} className='noinv-recs-td'>{moment.utc(noinv[col.name]).local().startOf('minute').format('MM/DD/YYYY hh:mm a')}</td>
                                    )
                                } else {
                                    return (
                                        <td key={colindex} className='noinv-recs-td'>{noinv[col.name]}</td>
                                    )
                                }
                                
                            })}
                            
                            

                        </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default NoInventories
